module.exports = __webpack_public_path__ + "img/welfare_img3.bec843a8.svg";